/**
 * listinfoHeaderScript.js — CHẠY `header` dạng script của field listinfo (luật thuần ở
 * listinfoProps.resolveScriptHeaders) với đủ thư viện + bộ nhớ đệm dùng chung cho cả phiên.
 *
 * Mọi chỗ dựng giao diện mới từ listinfo (DataDynamicPage.adaptListinfoToDataList, RecordLookupMenu…)
 * đi qua đây. Cùng một script hay lặp ở nhiều listinfo (vd nhãn "Nhóm vật tư" đọc từ groupkind ở mọi
 * chứng từ kho) nên kết quả được nhớ theo CÔNG TY + nội dung script — đổi công ty là khoá khác.
 */
import Moment from 'moment';
import * as utils from '../utils';
import { resolveScriptHeaders } from './listinfoProps';

const HEADER_SCRIPT_CACHE = new Map();

/** Trả mảng field MỚI với `header` đã là nhãn thật. Không bao giờ ném. */
export async function chayHeaderScript(fields, listInfo, context) {
  try {
    const rs = await resolveScriptHeaders(fields, { context, listInfo }, {
      Moment, Numeral: utils.numeral, utils,
      cache: HEADER_SCRIPT_CACHE,
      cacheKey: String(context?.config?.id_app || context?.appInfo?._id || ''),
    });
    for (const e of rs.errors) {
      console.warn(`[listinfo "${listInfo?.code || ''}"] field "${e.field}": header dạng script chạy lỗi (${e.error}) -> dùng tên field làm nhãn.`);
    }
    return rs.fields;
  } catch (e) {
    console.error('[listinfoHeaderScript] lỗi không mong đợi:', (e && e.message) || e);
    return Array.isArray(fields) ? fields : [];
  }
}
